import React, { useState, useEffect, useRef } from "react";
import * as Mui from "@mui/material";
import { Loader } from "components/Loader";
import { themes, scrollTop } from "services/constants";
import { tableRowSx } from "services/constants";
import { EligibleEmployeeHeader } from "../../Headers";
import { tooltipStyleProps } from "services/constants/Styles";

export const QualifiedMembers = ({ qualifiedMembersList }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const containerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [trigger, setTrigger] = useState(true);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  useEffect(() => {
    if (trigger) {
      setLoading(true);
      setTrigger(false);
    } else {
      setLoading(false);
    }
  }, [trigger]);

  return (
    <React.Fragment>
      {loading === true ? (
        <Loader info="Loading..." />
      ) : (
        <>
          <Mui.Grid container>
            <Mui.TableContainer
              sx={{ width: "100%", maxHeight: 740, mt: 2, ml: 2, mr: 2 }}
              ref={containerRef}
            >
              <Mui.Table className="border">
                <Mui.TableHead
                  sx={{
                    backgroundColor: themes.primary,
                    position: "sticky",
                    top: -1,
                    zIndex: 10,
                  }}
                >
                  <Mui.TableRow sx={tableRowSx}>
                    {EligibleEmployeeHeader.map((header) => (
                      <Mui.TableCell
                        sx={{ color: themes.headLine, fontWeight: "bold" }}
                      >
                        {header.name}
                      </Mui.TableCell>
                    ))}
                  </Mui.TableRow>
                </Mui.TableHead>

                <Mui.TableBody>
                  {qualifiedMembersList?.length === 0 ? (
                    <Mui.TableRow sx={tableRowSx}>
                      <Mui.TableCell colSpan={12}>
                        <Mui.Alert
                          severity="info"
                          sx={{ margin: 2, width: "100%" }}
                        >
                          No data available
                        </Mui.Alert>
                      </Mui.TableCell>
                    </Mui.TableRow>
                  ) : (
                    qualifiedMembersList
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((item) => (
                        <>
                          <Mui.TableRow sx={tableRowSx}>
                            {EligibleEmployeeHeader.map((header) => {
                              const value = item[header.key]
                                ? String(item[header.key])
                                : "N/A";
                              return (
                                <Mui.TableCell
                                  sx={{
                                    color: themes.headLine,
                                  }}
                                >
                                  {header.name === "Employee Name" ? (
                                    <Mui.Tooltip
                                      title={value}
                                      arrow
                                      slotProps={tooltipStyleProps}
                                    >
                                      <Mui.Box
                                        display="flex"
                                        alignItems="center"
                                        gap={1}
                                        maxWidth={120}
                                      >
                                        <Mui.Avatar
                                          alt={item.employee_name}
                                          src={item.image_url}
                                          sx={{ width: 23, height: 23 }}
                                        />
                                        <span
                                          style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            display: "block",
                                          }}
                                        >
                                          {value}
                                        </span>
                                      </Mui.Box>
                                    </Mui.Tooltip>
                                  ) : value.length > 10 ? (
                                    <Mui.Tooltip
                                      title={value}
                                      arrow
                                      slotProps={tooltipStyleProps}
                                    >
                                      <span
                                        style={{
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          display: "inline-block",
                                          maxWidth: 80,
                                        }}
                                      >
                                        {value}
                                      </span>
                                    </Mui.Tooltip>
                                  ) : (
                                    value
                                  )}
                                </Mui.TableCell>
                              );
                            })}
                          </Mui.TableRow>
                        </>
                      ))
                  )}
                </Mui.TableBody>
              </Mui.Table>
            </Mui.TableContainer>
            <Mui.Grid
              container
              sx={{ display: "flex", justifyContent: "flex-end" }}
            >
              {qualifiedMembersList?.length > 25 && (
                <Mui.TablePagination
                  className="custom-pagination"
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  component="div"
                  count={qualifiedMembersList?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              )}
            </Mui.Grid>
          </Mui.Grid>
        </>
      )}
    </React.Fragment>
  );
};
